
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 15 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.092 11.997H3.31a.458.458 0 0 1-.46-.454c0-.25.207-.455.46-.455h4.782c.252 0 .46.205.46.455s-.208.454-.46.454zM3.31 13.815h9.38c.252 0 .46.204.46.454s-.208.455-.46.455H3.31a.458.458 0 0 1-.46-.455c0-.25.207-.454.46-.454z","fill":"#48626F"}}),_c('path',{attrs:{"d":"M14.5 4v12.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8.5m4 3l-4-3m4 3l-3.017 1.006a1 1 0 0 1-1.31-1.06L10.5 1","stroke":"#48626F"}})])
      }
    
      }
    